import { render, staticRenderFns } from "./nachweis-doppel-baeyer.vue?vue&type=template&id=523b9f72&"
import script from "./nachweis-doppel-baeyer.vue?vue&type=script&lang=js&"
export * from "./nachweis-doppel-baeyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports